import { ExpertiseSubCategoryWrapper } from './expertisesubcategorywrapper';

export class ExpertiseCategoryDataWrapper {
  public categories: ExpertiseCategoryWrapper[] = [];
}

export class ExpertiseCategoryWrapper {
  public categoryId: number = 0;
  public name: string = '';
  public linkedChildCategoriesCount: number = 0;
  public categories?: ExpertiseSubCategoryWrapper[] = [];
  public parentCategoryId: number = 0;
}

export class SelectedCategoryResponseWrapper {
  public categories: ExpertiseSelectedCategory[] = [];
}

export class ExpertiseSelectedCategory {
  public categoryId: number = 0;
  public categoryName: string = '';
  public categoryDesc: string = '';
  public userCategoryXRefId: number = 0;
}
